import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ar from '../src/locales/ar';
import fr from '../src/locales/fr';
import en from '../src/locales/en';

const VALID_LANGS = ['ar', 'fr', 'en'];
const STORAGE_KEY = 'i18nextLng';

const readSavedLang = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

const savedLang = readSavedLang();
const initialLang = savedLang && VALID_LANGS.includes(savedLang) ? savedLang : 'ar';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      fr: { translation: fr },
      en: { translation: en },
    },
    lng: initialLang,
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    // storage unavailable (private mode): the choice just isn't remembered
  }
});

export default i18n;
